<template>
    <div class="table">

        <!-- 页面标题 start -->
        <div class="page_title">
            {{$i18n.t("mainIndex.text1")}}
        </div>
        <!-- 页面标题 end -->

        <!-- 卡片 start -->
        <el-card
            :body-style="{
                textAlign: 'left',
                padding: '16px',
                maxWidth: '1760px',
                margin: '0 auto'
            }"
            shadow="never">

            <!-- 筛选条件表单 start -->
            <el-form :inline="true" size="small" :model="productForm" style="margin-bottom: 6px;">
                <el-form-item>
                    <el-input v-model.trim="productForm.keyword" clearable :placeholder="$i18n.t('mainIndex.text2')" @clear="getMsg(1)"
                              @keyup.enter.native="getMsg(1)" @blur="getMsg(1)" :maxlength="32"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-cascader
                        clearable
                        @change="getMsg(1)"
                        :show-all-levels="false"
                        :placeholder="$i18n.t('mainIndex.text3')"
                        v-model="productForm.productType"
                        :options="productTypeList"
                        :props="props">
                    </el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-select @change="getMsg(1)" style="width: 250px;" :popper-append-to-body="false" v-model="productForm.communication" clearable :placeholder="$i18n.t('mainIndex.text4')">
                        <el-option
                            v-for="item in $message.protocolTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select @change="getMsg(1)" :popper-append-to-body="false" v-model="productForm.state" clearable :placeholder="$i18n.t('mainIndex.text5')">
                        <el-option
                            v-for="item in $message.productStatusList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--                <el-form-item>-->
                <!--                    <el-button type="primary" icon="el-icon-search" @click="getMsg(1); btnLoading = true;" :loading="btnLoading" plain>搜索</el-button>-->
                <!--                </el-form-item>-->
            </el-form>
            <!-- 筛选条件表单 end -->

            <el-divider></el-divider>

            <!-- 卡片列表 start -->
<!--            <el-row :gutter="24" class="product_list" v-loading="loading">-->
<!--                <el-col :span="4" style="margin-top: 15px;">-->
<!--                    <div class="product_item" style="cursor: pointer;" @click="addProduct">-->
<!--                        <i class="add_product el-icon-plus"></i>-->
<!--                    </div>-->
<!--                </el-col>-->
<!--                <el-col :span="4" style="margin-top: 15px;" v-for="(item, index) in productMsg.list" :key="index">-->
<!--                    <div class="product_item">-->
<!--                        <div class="product_status" :style="{-->
<!--                            backgroundColor: $config.getMsgItemUtil($message.productStatusColorList,item.status,'id','name')-->
<!--                        }">-->
<!--                            {{ $config.getMsgItemUtil($message.productStatusList, item.status, 'id', 'name') }}-->
<!--                        </div>-->
<!--                        <el-image-->
<!--                            style="width: 120px;height: 120px;padding: 0 5px 16px 5px;"-->
<!--                            :src="item.icon"-->
<!--                            :preview-src-list="[item.icon]">-->
<!--                            <div slot="error">-->
<!--                                <div class="image_slot">-->
<!--                                    {{$i18n.t('mainIndex.text6')}}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </el-image>-->
<!--                        <el-row>-->
<!--                            <el-col :span="22">-->
<!--                                <div class="product_msg">-->
<!--                                    <div class="product_name" :title="item.name">{{ item.name }}</div>-->
<!--                                    <div class="product_pid" :title="item.pid">{{ item.pid }}</div>-->
<!--                                </div>-->
<!--                            </el-col>-->
<!--                            <el-col :span="2" style="text-align: left;">-->
<!--                                <el-dropdown-->
<!--                                    trigger="click"-->
<!--                                    size="small"-->
<!--                                    placement="bottom-end"-->
<!--                                    @command="handleCommand">-->
<!--                                    <span class="el-dropdown-link">-->
<!--                                        <i class="product_gd_icon icon-gengduo"></i>-->
<!--                                    </span>-->
<!--                                    <el-dropdown-menu slot="dropdown">-->
<!--                                        <el-dropdown-item :command="beforeHandleCommand(0, item)">{{$i18n.t('mainIndex.text7')}}</el-dropdown-item>-->
<!--                                        <el-dropdown-item :command="beforeHandleCommand(1, item)">{{$i18n.t('mainIndex.text8')}}</el-dropdown-item>-->
<!--                                        <el-dropdown-item v-if="item.status !== 3"-->
<!--                                                          :command="beforeHandleCommand(2, item)">{{$i18n.t('mainIndex.text9')}}-->
<!--                                        </el-dropdown-item>-->
<!--                                        <el-dropdown-item :command="beforeHandleCommand(3, item)"-->
<!--                                                          v-if="item.status === 3">{{$i18n.t('mainIndex.text10')}}-->
<!--                                        </el-dropdown-item>-->
<!--                                        <el-dropdown-item :command="beforeHandleCommand(4, item)"-->
<!--                                                          v-if="item.status === 3">{{$i18n.t('mainIndex.text11')}}-->
<!--                                        </el-dropdown-item>-->
<!--                                    </el-dropdown-menu>-->
<!--                                </el-dropdown>-->
<!--                            </el-col>-->
<!--                        </el-row>-->
<!--                    </div>-->
<!--                </el-col>-->
<!--            </el-row>-->
            <!-- 卡片列表 end -->

            <!--新卡片列表 start-->
            <div class="product_list" v-loading="loading">
                <div class="product_item" style="cursor: pointer;" @click="addProduct">
                    <i class="add_product el-icon-plus"></i>
                </div>

                <div class="product_item" v-for="(item, index) in productMsg.list" :key="index">
                    <div class="product_status" :style="{
                            backgroundColor: $config.getMsgItemUtil($message.productStatusColorList,item.status,'id','name')
                        }">
                        {{ $config.getMsgItemUtil($message.productStatusList, item.status, 'id', 'name') }}
                    </div>
                    <el-image
                        style="width: 120px;height: 120px;padding: 0 5px 16px 5px;"
                        :src="item.icon"
                        :preview-src-list="[item.icon]">
                        <div slot="error">
                            <div class="image_slot">
                                {{$i18n.t('mainIndex.text6')}}
                            </div>
                        </div>
                    </el-image>
                    <el-row>
                        <el-col :span="22">
                            <div class="product_msg">
                                <div class="product_name" :title="item.name">{{ item.name }}</div>
                                <div class="product_pid" :title="item.pid">{{ item.pid }}</div>
                            </div>
                        </el-col>
                        <el-col :span="2" style="text-align: left;">
                            <el-dropdown
                                trigger="click"
                                size="small"
                                placement="bottom-end"
                                @command="handleCommand">
                                    <span class="el-dropdown-link">
                                        <i class="product_gd_icon icon-gengduo"></i>
                                    </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :command="beforeHandleCommand(0, item)">{{$i18n.t('mainIndex.text7')}}</el-dropdown-item>
                                    <el-dropdown-item :command="beforeHandleCommand(1, item)">{{$i18n.t('mainIndex.text8')}}</el-dropdown-item>
                                    <el-dropdown-item v-if="item.status !== 3"
                                                      :command="beforeHandleCommand(2, item)">{{$i18n.t('mainIndex.text9')}}
                                    </el-dropdown-item>
                                    <el-dropdown-item :command="beforeHandleCommand(3, item)"
                                                      v-if="item.status === 3">{{$i18n.t('mainIndex.text10')}}
                                    </el-dropdown-item>
                                    <el-dropdown-item :command="beforeHandleCommand(4, item)"
                                                      v-if="item.status === 3">{{$i18n.t('mainIndex.text11')}}
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!--新卡片列表 end-->

            <!-- 分页器 start -->
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :page-size="14"
                layout="prev, pager, next"
                style="margin-top: 10px;display: flex;flex-direction: row;justify-content: flex-end;"
                :current-page.sync="page"
                :total="parseInt(productMsg.totalRecords)">
            </el-pagination>
            <!-- 分页器 end -->

        </el-card>
        <!-- 卡片 end -->

        <div style="height: 1px;"></div>
    </div>
</template>

<script>

import {mapState, mapActions} from "vuex";

export default {

    data() {

        return {

            loading: false,

            btnLoading: false,

            //表格高度
            tableHeight: 50,

            //查询表单
            productForm: {
                //产品名称/PID
                keyword: "",
                //品类code
                productType: "",
                //通讯方式
                communication: "",
                //产品状态
                state: ""
            },

            //级联选择器配置选项
            props: {
                //开启懒加载
                lazy: true,
                //指定选项的值为选项对象的某个属性值
                value: "code",
                //指定选项标签为选项对象的某个属性值
                label: "name",
                //指定选项的子选项为选项对象的某个属性值
                children: "children",
                //加载动态数据的方法
                //node为当前点击的节点，resolve为数据加载完成的回调(必须调用)
                lazyLoad: (node, resolve) => {
                    console.log(node);
                    if (!node.value) {
                        //获取一级品类
                        this.getProtocolTypeList();
                        return
                    }
                    this.getLevelProtocolTypeList(node.value, resolve)
                }
            },

            //当前页
            page: 1,

            //品类数据
            productTypeList: [],

            //数据源
            productMsg: {
                list: [],
                totalRecords: 100000
            }

        }

    },

    mounted() {
        //动态加载表格高度
        setTimeout(() => {
            this.tableHeight = window.innerHeight - 245 - 25;
        }, 100)
        window.addEventListener('resize', this.setHeight);
        let page = (this.$route.query.page && this.$route.query.page !== '') ? Number(this.$route.query.page) : 1
        //获取数据
        this.getMsg(page);
    },

    destroyed() {
        window.removeEventListener('resize', this.setHeight)
    },

    methods: {

        ...mapActions('product', ['queryProduct', 'deleteProduct']),
        ...mapActions('category', ['queryFirstLevelCategory', 'queryChildsCategory']),

        /**
         * 高度适配
         */
        setHeight() {
            this.tableHeight = window.innerHeight - 245 - 8;
        },

        /**
         * 点击操作省略号后获得行号与行数据
         * @param index 行号
         * @param row 行数据
         * @returns {{index, row}}
         */
        beforeHandleCommand(index, row) {
            return {
                index: index,
                row: row,
            };
        },

        /**
         * 点击省略号回调
         * @param command
         */
        handleCommand(command) {
            console.log(command)
            switch (command.index) {
                //编辑产品
                case 0:
                    this.modify(command.row);
                    break;
                //复制产品
                case 1:
                    this.copy(command.row);
                    break;
                //删除产品
                case 2:
                    this.delProduct(command.row);
                    break;
                //设备管理
                case 3:
                    this.$router.push({path: "/deviceManagement", query: {pid: command.row.pid}});
                    break;
                //OTA升级
                case 4:
                    this.$router.push({
                        path: "/ota",
                        query:
                            {
                                id: command.row.code,
                                type: 1
                            }
                    });
                    break;
            }
        },

        /**
         * 获取产品列表
         * @param page
         */
        getMsg(page) {
            if (page) this.page = page;
            this.loading = true;
            this.queryProduct({
                categoryCode: this.productForm.productType[2],
                currPage: this.page,
                pageSize: 14,
                keyword: this.productForm.keyword,
                productStatus: this.productForm.state,
                protocolType: this.productForm.communication,
            }).then(res => {
                this.productMsg = res.result;
            }, err => {
                console.log(err);
                this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
            }).finally(() => {
                this.btnLoading = false;
                this.loading = false;
            })
        },

        /**
         * 获取产品类型列表
         */
        getProtocolTypeList() {
            this.queryFirstLevelCategory().then(res => {
                if (res.result.length == 0) return
                res.result.forEach(item => {
                    item.name = localStorage.getItem('language') === 'zh' ? JSON.parse(item.name).zh : JSON.parse(item.name).en;
                    item.leaf = false;
                })
                this.productTypeList = res.result
            }, err => {
                console.log(err);
                this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
            });
        },

        /**
         * 获取下级产品类型列表
         * @param code
         * @param resolve
         */
        getLevelProtocolTypeList(code, resolve) {
            this.queryChildsCategory({
                code
            }).then(res => {
                res.result.forEach(item => {
                    item.name = localStorage.getItem('language') === 'zh' ? JSON.parse(item.name).zh : JSON.parse(item.name).en;
                    if (item.level == 2) {
                        item.children = [];
                        item.leaf = false;
                    }
                    if (item.level == 3) {
                        item.leaf = true;
                    }
                })
                console.log(res.result)
                resolve(res.result)
            }, err => {
                console.log(err);
                this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
            })
        },

        /**
         * 复制产品
         * @param row
         */
        copy(row) {
            this.$store.commit("main/SET_COPY_PRODUCT_DIALOG_VISIBLE", true);
            this.$store.commit("main/SET_PRODUCTITEM_ITEM_MSG", row);
        },

        /**
         * 分页点击回调
         * @param page
         */
        handleCurrentChange(page) {
            this.page = page;
            this.$config.changeURLArg('page', this.page);
            this.getMsg()
        },

        /**
         * 删除产品
         * @param row
         */
        delProduct(row) {
            this.$dialog.showConfirm({
                content: this.$i18n.t("mainIndex.text12"),
                title: this.$i18n.t("mainIndex.text13"),
                btn1: this.$i18n.t("mainIndex.text14"),
                btn2: this.$i18n.t("mainIndex.text15"),
                icon: 2
            }, () => {
                this.loading = true;
                this.deleteProduct({
                    productCode: row.code
                }).then(res => {
                    this.$dialog.showMessage(this.$i18n.t("mainIndex.text15"), this.$config.TOAST_SUCCESS);
                    this.getMsg();
                }, err => {
                    console.log(err);
                    this.loading = false;
                    this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
                })
            })
        },

        /**
         * 编辑产品
         * @param row
         */
        modify(row) {
            this.$router.push({path: "/product", query: {id: row.code}});
        },

        /**
         * 添加产品
         */
        addProduct() {
            this.$router.push({path: "/addProduct"});
        }

    }

}
</script>

<style scoped>
.el-card {
    width: calc(100% - 48px);
    border: none;
    border-radius: 8px;
    margin: 64px 24px 24px 24px;
    animation: fadeInRight; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 1s; /* don't forget to set a duration! */
}

.table {
    width: 100%;
    height: calc(100% - 75px - 8px);
}

/deep/ .el-card__header {
    padding: 10px 10px 10px 15px !important;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    border: none;
}

/deep/ .el-divider--horizontal {
    width: calc(100% + 30px) !important;
    margin: 0 -15px 0 -15px !important;
}

.el-divider {
    background-color: #E9E9E9 !important;
}

/deep/ .el-form--inline .el-form-item {
    margin-right: 16px!important;
}

.product_list {
    width: calc(100%);
    padding-bottom: 10px;
    display: grid;
    grid-template-columns: repeat(auto-fill, calc(20% - 16px)); /* 动态列数 */
    gap: 20px;
    margin-top: 15px;
}

.el-form-item {
    margin-bottom: 10px;
}

.el-input {
    width: 200px;
}

.el-select {
    width: 150px;
}

.add_product {
    line-height: 190px;
    font-size: 50px;
}

.product_item {
    position: relative;
    width: 100%;
    height: 190px;
    background: #FFFFFF;
    box-shadow: 0 0 4px 0 #BCBCBC;
    border-radius: 8px;
    text-align: center;
    animation: fadeInRight; /* referring directly to the animation's @keyframe declaration */
    animation-duration: 2s; /* don't forget to set a duration! */
}

.product_msg {
    height: 50px;
    background: #F7F7F7;
    border-radius: 8px;
    margin: -14px 10px 10px 10px;
}

.product_gd_icon {
    font-family: "iconfont" !important;
    font-size: 20px;
    color: #555555;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-top: 6px;
    margin-left: -40%;
    display: block;
    cursor: pointer;
}

.product_name, .product_pid {
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.product_name {
    padding-top: 10px;
}

.product_pid {
    font-size: 10px;
    margin-top: 5px;
}

.product_status {
    position: absolute;
    right: 0;
    top: 0;
    padding: 0 10px;
    height: 24px;
    border-radius: 0 8px 0 8px;
    z-index: 7;
    color: white;
    font-weight: 400;
    line-height: 24px;
    font-size: 12px;
    text-align: center;
}

.image_slot {
    width: 126px;
    height: 126px;
    font-size: 12px;
    line-height: 126px;
    color: #c0c4cc;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
    background: #00000000;
    border-radius: 10px;
    margin-top: 10px;
}


</style>
